import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { brandingService } from "services";
import { uiActions } from "store";
import { BrandingSettingsTypes, ErrorResponse } from "types";

const useSetBrandingColorsSettingsAgentMutation = (agentId: string) => {
	const dispatch = useDispatch();

	return useMutation(
		({ settings }: { settings: BrandingSettingsTypes }) => {
			return brandingService.setBrandingColorsSettingsAgent({
				agentId,
				settings: {
					background_color: settings.colorBackground,
					header_footer_color: settings.colorHeader,
					text_color: settings.colorText,
				},
			});
		},
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useSetBrandingColorsSettingsAgentMutation;
